import axios from '@/utils/request';

function ADD(params) {
    return axios.get("/customer/AVersion/add", {
        params: params
    })
}

export default {
    ADD
};